import { Inject, Injectable, OnDestroy } from '@angular/core';
import Utils from '@iv/shared/utils';
import { User } from 'app/pages/domain/user';
import { CommonService } from './core/services/common.service';
import { Destroyer } from 'app/common/utils';
import { PermissionTypes } from '@iv/store/permissions/permissions.models';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import * as PermissionActions from '@iv/store/permissions/permissions.actions';
import { getPermissions } from '@iv/store/permissions/permissions.reducer';
import { takeUntil } from 'rxjs/operators';
import { IUserSubscription } from 'app/core/interfaces/user-settings.interface';
import { ActivatedRoute, Params } from "@angular/router";

// TODO: Навести порядок в логике авторизации
@Injectable({ providedIn: 'root' })
export class LoginService extends Destroyer implements OnDestroy {

  private token: string;
  // TODO: Убрать логики ВСЕГО приложение использование userId и uuid в ввиду их наличия в token
  private uuid: string;
  private userId: string;

  public constructor(
    private route: ActivatedRoute,
    private commonService: CommonService,
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
    super();

    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: Params) => {
        const {token, uuid, userId} = params as { token: string; uuid: string; userId: string };
        this.token = token;
        this.uuid = uuid;
        this.userId = userId;

        Utils.setToken(this.token);
      });

    window.addEventListener('message', event => {
      if (event.data.token) {
        this.token = event.data.token;
        Utils.setToken(this.token);
      }
    });
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  public initUser(isDashboard?: boolean): Promise<any> { // TODO: isDashboard - временный костыль, убрать после перезда дашборда в ivolatility
    sessionStorage.clear();
    const user: User = new User(+this.userId, this.uuid);
    Utils.setUser(user);
    if (this.userId) {
      return new Promise((resolve, reject) => {
        if (this.token) {
          Utils.setToken(this.token);
          resolve(user);
        } else {
          reject(Utils.getError('TokenError', 'token is not correct'));
        }
      })
        .then((resolveUser: User) => {
          return new Promise((resolve, reject) => {
            if (isDashboard) {
              resolve(resolveUser);
              return;
            }

            this.commonService.getPermissions()
              .subscribe((permissions: PermissionTypes[]) => {
                this.store.dispatch(PermissionActions.addPermission(permissions));

                if (!localStorage.getItem('permissions')) {
                  localStorage.setItem('permissions', getPermissions(this.store.getState()).join(';'));
                }

                resolve(resolveUser);
              }, reject);
          });
        })
        .then((resolveUser: User) => {
          return new Promise((resolve, reject) => {
            if (isDashboard) {
              resolve(resolveUser);
              return;
            }

            this.commonService.getGroupSubscription()
              .subscribe((userSubscriptions: IUserSubscription[]) => {
                this.commonService.userSubscriptions = userSubscriptions;
                resolve(resolveUser);
              }, reject);
          });
        })
        .catch(error => {
          return new Promise((reject) => {
            if (error.name === 'UserNotFoundError') {
              this.redirectToLogin();
            }
            reject(error);
          });
        });
    } else {
      return new Promise((reject) => {
        this.redirectToLogin();
        reject();
      });
    }
  }

  private redirectToLogin(): void {
    window.parent.postMessage('REDIRECT_LOGIN', '*');
  }
}
